import React, { type ReactNode } from 'react';
import DCFMarkdown from '../DCFMarkdown/DCFMarkdown';

type Props = {
  children: JSX.Element;
  title: ReactNode;
  hintText?: string;
  legendId?: string;
  showRequiredAsterisk?: boolean;
  'data-testid'?: string;
};

function Fieldset({
  children,
  title,
  hintText,
  legendId,
  showRequiredAsterisk,
  'data-testid': testId,
}: Props) {
  return (
    <fieldset className="govuk-fieldset fieldset-container" data-testid={testId ?? ''}>
      <legend className="govuk-fieldset__legend govuk-fieldset__legend--m" id={legendId}>
        <h2
          className={`govuk-fieldset__heading ${showRequiredAsterisk ? 'required-question-label' : ''}`}
        >
          {title}
        </h2>
      </legend>
      {hintText ? (
        <DCFMarkdown content={hintText} type="hint-text" />
      ) : (
        <hr className="govuk-section-break empty-hint-section-break" />
      )}
      {children}
    </fieldset>
  );
}

export default Fieldset;
